import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const repeatService = {
  namespaced: true,
  state: {
    summary: ''
  },
  getters,
  mutations,
  actions
}
